















import Vue from 'vue'
import { debounce } from 'debounce'
import SplashScreen from '@/types/components/SplashScreen.interface'
import SplashLoader from '@/components/SplashLoader.vue'

export default Vue.extend({
    components: { SplashLoader },
    data: () => ({
        showSplash: false
    }),
    mounted() {
        //  If splash screen is NOT null then set our splash to true
        if (this.splash) this.showSplash = true
    },
    computed: {
        message(): string {
            //  If we have a splash message, return it
            if (this.splash) return this.splash.message

            //  Else, just return 'Complete'
            return 'Completed'
        },
        splash(): SplashScreen {
            return this.$store.getters.splash
        }
    },
    methods: {
        disableSplash: debounce(function () {
            this.showSplash = false
        }, 250)
    },
    watch: {
        splash(val: boolean): void {
            //  If splash goes null, call our disable splash function
            if (!val) this.disableSplash()
            //  Else, set show splash to true
            else this.showSplash = true
        }
    }
})
